// Sezione dati impianto calcolati automaticamente dai materiali selezionati
import { Badge } from '../../ui/badge';
import { Label } from '../../ui/label';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';
import { Sun } from '@phosphor-icons/react';
import { PLANT_TYPES } from './constants';

export const PlantDataSection = ({ quote, isEditable, onUpdateQuote, calculatedPlantData }) => (
    <div className="space-y-3">
        <div className="flex items-center gap-2">
            <Sun className="w-4 h-4 text-amber-500" />
            <Label className="text-base font-semibold">Dati Impianto</Label>
            <Badge variant="secondary" className="text-xs">Calcolati dai Materiali</Badge>
        </div>
        <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
                <Label>Tipologia</Label>
                {isEditable ? (
                    <Select
                        value={quote.plant_data?.tipologia || 'residenziale'}
                        onValueChange={(v) => onUpdateQuote({
                            plant_data: { ...quote.plant_data, tipologia: v }
                        })}
                    >
                        <SelectTrigger>
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {Object.entries(PLANT_TYPES).map(([k, v]) => (
                                <SelectItem key={k} value={k}>{v}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                ) : (
                    <p className="p-2 bg-zinc-50 rounded">{PLANT_TYPES[quote.plant_data?.tipologia]}</p>
                )}
            </div>
            <div className="space-y-2">
                <Label>Potenza Impianto</Label>
                <p className="p-2 bg-amber-50 rounded border border-amber-200 font-medium">
                    {calculatedPlantData.potenza_kwp || quote.plant_data?.potenza_kwp || '-'} kWp
                </p>
            </div>
            <div className="space-y-2">
                <Label>N. Moduli</Label>
                <p className="p-2 bg-amber-50 rounded border border-amber-200 font-medium">
                    {calculatedPlantData.numero_moduli || quote.plant_data?.numero_moduli || '-'}
                </p>
            </div>
            <div className="space-y-2">
                <Label>Sistema di Accumulo</Label>
                <p className="p-2 bg-amber-50 rounded border border-amber-200 font-medium">
                    {calculatedPlantData.has_accumulo
                        ? `${calculatedPlantData.accumulo_kwh} kWh`
                        : 'Non presente'}
                </p>
            </div>
        </div>
        <p className="text-xs text-zinc-500 italic">
            * I dati dell&apos;impianto vengono calcolati automaticamente in base ai materiali selezionati nella tab &quot;Materiali&quot;
        </p>
    </div>
);
